import { staffConnect } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IStaffConnect } from "../../models/staff/StaffCommunicationDetails";

export default new (class StaffService {
  public getStaffDetails = async (
    departmentId: number | undefined
  ): Promise<IApiResponse<IStaffConnect>> => {
    try {
      let endPoint = departmentId 
      ? urlBinder(staffConnect.GET_ALL_STAFF_CONNECT_WITH_DEPARTMENT, [`${departmentId}`])
      : staffConnect.GET_ALL_STAFF_CONNECT_WITHOUT_DEPARTMENT;
        const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStaffConnect>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStaffConnect>;
      } else {
        throw error;
      }
    }
  };
})();

